import { Divider, Flex } from 'antd'
import React from 'react'

import Page from '@/components/shared/page'

import CreatorOverviewChannels from './components/creator-overview/creator-overview-channels'
import CreatorOverviewEarningSummary from './components/creator-overview/creator-overview-earning-summary'
import CreatorOverviewStatistics from './components/creator-overview/creator-overview-statistics'
import CreatorOverviewTrends from './components/creator-overview/creator-overview-trends'
import s from './creator-reports.module.css'
import { ReportsPageProps } from './hooks/use-report-search'

export default function ChatterReportsOverview(props: ReportsPageProps) {

  return (
    <Page hideHeader contentClassName={s.creatorReportsOverview}>
      <Flex vertical>
        <CreatorOverviewEarningSummary {...props}/>
        <Divider/>
        <CreatorOverviewTrends  {...props}/>
        <Divider/>
        <CreatorOverviewChannels  {...props}/>
        <Divider/>
        <CreatorOverviewStatistics {...props}/>
      </Flex>
    </Page>
  )
}
